import { windowFF } from "./window";
export const getFeatureFlag = (flag, validator, fallback) => {
    const val = windowFF?.ff?.[flag];
    if (validator(val, flag)) {
        return val;
    }
    return fallback;
};
